import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGetLocationsPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/locations/get-locations-paginated.form-default-values';
import { GetLocationsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/locations/get-locations-paginated.model';
import { useState } from 'react';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterEmspBoLocationListContextProvider,
  useEmspBoEmspLocationListContext,
} from '../../emsp-bo-location.context';
import { EmspBoLocationListFilterFormController } from './emsp-bo-location-list-filter-form/emsp-bo-location-list-filter-form.controller';

interface EmspBoLocationListFilterControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const EmspBoLocationListFilterController = ({
  onCancel,
  onSuccess,
}: EmspBoLocationListFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useEmspBoEmspLocationListContext();
  const [multiStepFormState] = useState(MultiStepFormState.Default);

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<GetLocationsPaginatedModel> = (
    errors,
  ) => {
    Logger.error(errors);
    toast.error(
      t('$.emsp-bo-location-list-filter.error', {
        error: t('global.unknown'),
      }),
    );
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<
    GetLocationsPaginatedModel
  > = (fieldValues) => {
    setGetPaginatedQueryParameters((current) => ({
      ...current,
      cpoId: fieldValues.cpoId,
      country: fieldValues.country,
      city: fieldValues.city,
      name: fieldValues.name,
    }));
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGetLocationsPaginatedDefaultValues(
    getPaginatedQueryParameters,
  );

  return (
    <FilterEmspBoLocationListContextProvider data={data}>
      <EmspBoLocationListFilterFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
        state={multiStepFormState}
      />
    </FilterEmspBoLocationListContextProvider>
  );
};
